import { DASHBOARD_CONFIG } from '../constants/config';

export const findDashboardView = (viewName) =>
	DASHBOARD_CONFIG.find((component) => viewName in component);
